const contentWrapper = document.querySelector('#page');

const initSearchTabs = () => {
	// Existing selectors for desktop tab buttons and tab blocks
	const tabButtons = document.querySelectorAll(
		'.search-results__tab > .wp-block-button .wp-block-button__link'
	);

	// Mobile slider buttons
	const mobileTabButtons = document.querySelectorAll(
		'.mobile-slider__tab-button'
	);

	// Function to get query parameter by name
	const getQueryParam = (name) => {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name);
	};

	// Function to set the active tab based on the active_tab parameter
	const setActiveTab = (activeTabName) => {
		const tabButton = document.querySelector(
			`.search-results__tab[data-tab="${activeTabName}"] .wp-block-button`
		);

		if (tabButton) {
			// Handle desktop tabs
			const tabBlock = tabButton.closest('.search-results__tabs');
			const activeTabs = tabBlock.querySelectorAll(
				'.search-results__tab > .wp-block-button.active'
			);

			if (activeTabs.length) {
				activeTabs.forEach((activeTab) => {
					if (activeTab !== tabButton) {
						activeTab.classList.remove('active');
					}
				});
			}

			tabButton.classList.add('active');

			const tabPagination = document.querySelectorAll(
				`.search-results__tab[data-tab="${activeTabName}"] .pagination-wrapper a`
			);

			tabPagination.forEach((link) => {
				link.addEventListener('click', function () {
					contentWrapper.classList.add('loading');
				});
			});
		}

		// Handle mobile slider buttons
		const mobileButton = document.querySelector(
			`.mobile-slider__tab-button[data-tab="${activeTabName}"]`
		);

		if (mobileButton) {
			const activeMobileButtons = document.querySelectorAll(
				'.mobile-slider__tab-button.active'
			);

			if (activeMobileButtons.length) {
				activeMobileButtons.forEach((activeMobileButton) => {
					activeMobileButton.classList.remove('active');
				});
			}

			mobileButton.classList.add('active');
		}
	};

	//Set the correct tab on page load based on query parameter
	const activeTab = getQueryParam('active_tab');
	if (activeTab) {
		setActiveTab(activeTab);
	} else {
		// Default to the first tab (e.g., All Results)
		setActiveTab('all');
	}

	const toggleTab = (e, manualTabName = null) => {
		if (e) e.preventDefault();

		let activeTabName = '';

		if (e) {
			const tabBlock = e.currentTarget.closest('.search-results__tabs');
			if (!tabBlock) return;

			// Deactivate other active tabs
			const activeTabs = tabBlock.querySelectorAll(
				'.search-results__tab > .wp-block-button.active'
			);
			activeTabs.forEach((tab) => tab.classList.remove('active'));

			e.currentTarget.parentElement.classList.add('active');
			activeTabName =
				e.currentTarget.parentElement.parentElement.dataset.tab;
		} else if (manualTabName) {
			activeTabName = manualTabName;

			// Mobile buttons don't exist inside `.search-results__tabs` structure, so manually handle active classes
			const allMobileTabs = document.querySelectorAll(
				'.mobile-slider__tab-button'
			);
			allMobileTabs.forEach((btn) => btn.classList.remove('active'));

			const clickedMobileTab = document.querySelector(
				`[data-tab="${manualTabName}"]`
			);
			if (clickedMobileTab) clickedMobileTab.classList.add('active');

			const allDesktopTabs = document.querySelectorAll(
				'.search-results__tab > .wp-block-button'
			);
			allDesktopTabs.forEach((tab) => tab.classList.remove('active'));

			const correspondingDesktopTab = document.querySelector(
				`.search-results__tab[data-tab="${manualTabName}"] .wp-block-button`
			);
			if (correspondingDesktopTab)
				correspondingDesktopTab.classList.add('active');
		}

		if (!activeTabName) return;

		const hiddenActiveTab = document.getElementById(
			'search-hero__hidden_active_tab'
		);
		if (hiddenActiveTab) {
			hiddenActiveTab.value = activeTabName;
		}

		const url = new URL(window.location);
		const searchParam = url.searchParams.get('s') || '';
		const newUrl = new URL(
			window.location.origin + window.location.pathname
		);
		if (searchParam) {
			newUrl.searchParams.set('s', searchParam);
		}
		newUrl.searchParams.set('active_tab', activeTabName);

		window.history.pushState({}, '', newUrl);

		const currentTab = document.querySelector(
			'.search-results__tab:has(.active)'
		);

		// Check if this tab's .search-results__content is already populated.
		const searchContent = currentTab.querySelector(
			'.search-results__content'
		);

		if (searchContent && searchContent.classList.contains('loaded')) {
			//console.log('Content already loaded for:', activeTabName);
			// Optionally, display the total results from the cache
			updateTotalResultsFromCache(activeTabName, searchParam);
			return;
		}

		contentWrapper.classList.add('loading');

		const fetchURL = new URL(
			`${window.location.origin}/wp-json/propel/v1/search`
		);
		fetchURL.searchParams.set('s', searchParam);
		fetchURL.searchParams.set('active_tab', activeTabName);
		fetchURL.searchParams.set('per_page', 12);
		fetchURL.searchParams.set(`${activeTabName}_paged`, 1);

		// FETCH FROM REST API INSTEAD
		fetch(fetchURL, {
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		})
			.then((response) => {
				// Get the total from the response headers

				// Proceed to handle the JSON response
				return response.json().then((html) => {
					const newCurrentTab = document.querySelector(
						'.search-results__tab:has(.active)'
					);
					const searchContentWrapper = newCurrentTab.querySelector(
						'.search-results__content'
					);

					searchContentWrapper.classList.add('loaded');
					searchContentWrapper.innerHTML = '';

					// If no results, render the no_results HTML
					if (html.no_results) {
						searchContentWrapper.innerHTML = html.no_results;
						// Optionally, display the total results from the cache
						updateTotalResultsFromCache(activeTabName, searchParam);
					} else {
						// Get total posts only if there are results
						let totalPosts = response.headers.get('X-WP-Total')
							? response.headers.get('X-WP-Total')
							: 0;
						totalPosts = parseInt(totalPosts);

						if (!isNaN(totalPosts)) {
							sessionStorage.setItem(
								`totalPosts_${activeTabName}`,
								totalPosts
							);
						}
						// Loop through each result and append the card HTML
						html.results.forEach((item) => {
							const card = document.createElement('div');
							card.innerHTML = item.card_html;
							Array.from(card.children).forEach((child) => {
								searchContentWrapper.appendChild(child);
							});
						});

						// Optionally, display the total results from the cache
						updateTotalResultsFromCache(activeTabName, searchParam);

						// Append pagination if available
						if (html.pagination) {
							searchContentWrapper.insertAdjacentHTML(
								'beforeend',
								html.pagination
							);
						}
					}

					contentWrapper.classList.remove('loading');
				});
			})
			.catch((error) => {
				console.error('Error fetching tab content:', error); // eslint-disable-line no-console
			});
	};

	// Add event listeners for desktop tab buttons
	if (tabButtons.length) {
		tabButtons.forEach((tabButton) => {
			tabButton.addEventListener('click', toggleTab);
		});
	}

	// Add event listeners for mobile slider buttons
	if (mobileTabButtons.length) {
		mobileTabButtons.forEach((mobileButton) => {
			mobileButton.addEventListener('click', (e) => {
				e.preventDefault();
				const tabName = mobileButton.getAttribute('data-tab');
				setActiveTab(tabName);
				toggleTab(null, tabName);
			});
		});
	}
};

function clearTotalPostsCache() {
	for (let i = sessionStorage.length - 1; i >= 0; i--) {
		const key = sessionStorage.key(i);
		if (key && key.startsWith('totalPosts_')) {
			sessionStorage.removeItem(key);
		}
	}
}

// Function to update the total results from sessionStorage
function updateTotalResultsFromCache(activeTabName, searchParam) {
	const totalResultsWrapper = document.querySelector(
		'.search-hero__current-selected'
	);

	if (!totalResultsWrapper) return;

	const totalResultsElement = totalResultsWrapper.querySelector('p');

	const capitalizedTabName =
		activeTabName.charAt(0).toUpperCase() + activeTabName.slice(1);

	const displayTabName =
		activeTabName === 'all' ? '' : `${capitalizedTabName} `;

	const totalPosts = sessionStorage.getItem(`totalPosts_${activeTabName}`);

	if (totalPosts && parseInt(totalPosts) > 0) {
		// Set text for actual results
		totalResultsElement.textContent = `${totalPosts} ${displayTabName} results for: "${searchParam}"`;
	} else {
		// Set text to 0 if no results
		totalResultsElement.textContent = `0 ${displayTabName} results for: "${searchParam}"`;
	}
}

document
	.querySelector('.search-results__wrapper')
	?.addEventListener('click', (e) => {
		const link = e.target.closest('.pagination-wrapper .page-numbers');
		if (!link) return;

		e.preventDefault();
		const url = new URL(link.href);
		const activeTab = url.searchParams.get('active_tab') || 'all';
		const page = url.searchParams.get(`${activeTab}_paged`) || 1;
		const search = url.searchParams.get('s') || '';

		fetchPaginatedResults(activeTab, page, search);
	});

function getCurrentSearchParams() {
	const url = new URL(window.location);
	const searchParam = url.searchParams.get('s') || '';
	const activeTabName = url.searchParams.get('active_tab') || 'all';

	// Dynamically get the page number for the active tab
	const pageParamName = `${activeTabName}_paged`;
	const page = parseInt(url.searchParams.get(pageParamName)) || 1;

	return {
		searchParam,
		activeTabName,
		page,
	};
}

// Function to handle fetching and updating results and pagination
function fetchPaginatedResults(activeTab, page, search) {
	// Check if the request is already in progress
	contentWrapper.classList.add('loading');
	const searchParam = search; // Replace with dynamic search param
	const activeTabName = activeTab; // Replace with dynamic active tab name

	// Update the URL params for pagination
	const updatedUrl = new URL(window.location);

	// Set the correct tab
	updatedUrl.searchParams.set('active_tab', activeTabName);

	// Set the correct pagination param for the active tab
	updatedUrl.searchParams.set(`${activeTabName}_paged`, page);

	// Keep the search param if it exists
	if (searchParam) {
		updatedUrl.searchParams.set('s', searchParam);
	}

	// Push the updated URL without reloading
	window.history.pushState({}, '', updatedUrl);

	fetch(
		`/wp-json/propel/v1/search?s=${encodeURIComponent(
			searchParam
		)}&active_tab=${encodeURIComponent(
			activeTabName
		)}&per_page=12&${encodeURIComponent(activeTabName)}_paged=${page}`,
		{
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		}
	)
		.then((response) => {
			// Proceed to handle the JSON response
			return response.json().then((html) => {
				const currentTab = document.querySelector(
					'.search-results__tab:has(.active)'
				);
				const searchContentWrapper = currentTab.querySelector(
					'.search-results__content'
				);

				searchContentWrapper.classList.add('loaded');
				searchContentWrapper.innerHTML = '';

				// If no results, render the no_results HTML
				if (html.no_results) {
					searchContentWrapper.innerHTML = html.no_results;
					// Optionally, display the total results from the cache
					updateTotalResultsFromCache(activeTabName, searchParam);
				} else {
					// Get total posts only if there are results
					let totalPosts = response.headers.get('X-WP-Total')
						? response.headers.get('X-WP-Total')
						: 0;
					totalPosts = parseInt(totalPosts);

					if (!isNaN(totalPosts)) {
						sessionStorage.setItem(
							`totalPosts_${activeTabName}`,
							totalPosts
						);
					}
					// Loop through each result and append the card HTML
					html.results.forEach((item) => {
						const card = document.createElement('div');
						card.innerHTML = item.card_html;
						Array.from(card.children).forEach((child) => {
							searchContentWrapper.appendChild(child);
						});
					});

					// Optionally, display the total results from the cache
					updateTotalResultsFromCache(activeTabName, searchParam);

					// Append pagination if available
					if (html.pagination) {
						searchContentWrapper.insertAdjacentHTML(
							'beforeend',
							html.pagination
						);
					}
				}

				contentWrapper.classList.remove('loading');
				const element = document.getElementById('top');
				element.scrollIntoView({ behavior: 'smooth', block: 'start' });
			});
		})
		.catch((error) => {
			console.error('Error fetching tab content:', error); // eslint-disable-line no-console
		});
}

const initEPSearchContainer = () => {
	const epAutosuggestHero = document.querySelector(
		'.search-hero .ep-autosuggest'
	);

	if (epAutosuggestHero) {
		const suggestedHeading = document.createElement('h3');
		suggestedHeading.innerText = 'Suggested Searches';
		suggestedHeading.classList.add('search-hero__search-heading');
		epAutosuggestHero.insertBefore(
			suggestedHeading,
			epAutosuggestHero.firstChild
		);
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		clearTotalPostsCache();
		initSearchTabs();
		const { searchParam, activeTabName, page } = getCurrentSearchParams();

		fetchPaginatedResults(activeTabName, page, searchParam);
	},
	loaded() {
		initEPSearchContainer();
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
